export const RELATIONSHIP_OPTIONS = [
  { value: "", label: "Select relationship" },
  { value: "self", label: "Self" },
  { value: "son", label: "Son" },
  { value: "daughter", label: "Daughter" },
  { value: "spouse", label: "Spouse" },
  { value: "grandchild", label: "Grandchild" },
  { value: "parent", label: "Parent" },
  { value: "siblings", label: "Siblings" },
  { value: "relative", label: "Relative" },
  { value: "friend", label: "Friend" },
  { value: "other", label: "Others (mention)" },
];

export const GENDER_OPTIONS = [
  { value: "", label: "Select gender" },
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
];

/** Multi-select medical condition chips on the patient dossier. */
export const MEDICAL_CONDITION_OPTIONS = [
  { value: "alzheimers", label: "Alzheimer's" },
  { value: "diabetes", label: "Diabetes" },
  { value: "hypertension", label: "Hypertension" },
  { value: "parkinsons", label: "Parkinson's" },
  { value: "osteoarthritis", label: "Osteoarthritis" },
  { value: "post_stroke", label: "Post-Stroke Care" },
  { value: "extreme_frailty", label: "Extreme Frailty" },
  { value: "copd", label: "COPD" },
];

export const PRIMARY_DIAGNOSIS_OPTIONS = [
  { value: "", label: "Select primary condition (optional)" },
  { value: "diabetes", label: "Diabetes" },
  { value: "hypertension", label: "Hypertension" },
  { value: "stroke", label: "Stroke / paralysis" },
  { value: "dementia", label: "Dementia / Alzheimer's" },
  { value: "parkinsons", label: "Parkinson's disease" },
  { value: "heart_disease", label: "Heart disease" },
  { value: "cancer", label: "Cancer (active recovery)" },
  { value: "arthritis", label: "Arthritis / joint issues" },
  { value: "post_surgery", label: "Post-surgery recovery" },
  { value: "other", label: "Other (specify below)" },
];

/** Customer hire / signup popup — step labels */
export const CUSTOMER_SIGNUP_STEPS = {
  account: { index: 1, total: 2, title: "Account Registration" },
  /** Last create-account step; risk assessment & full patient details happen on the dashboard. */
  seniorProfile: { index: 2, total: 2, title: "Patient Profile" },
  healthAssessment: { index: 3, total: 4, title: "Patient Risk Assessment" },
  preferences: { index: 4, total: 4, title: "Preferred caregivers" },
  confirmation: { index: 4, total: 4, title: "Booking request sent" },
};

/** Legacy yes/no questions (kept for older forms / hire onboarding mirrors). */
export const SENIOR_HEALTH_QUESTIONS = [
  { id: "fallRisk", label: "Is the patient at risk of falls?" },
  { id: "dementia", label: "Does the patient have dementia or memory loss?" },
  { id: "bedridden", label: "Is the patient bedridden?" },
  { id: "mobilitySupport", label: "Is mobility support required?" },
  { id: "dailyTasks", label: "Does the patient need help with daily tasks?" },
  { id: "chronicConditions", label: "Does the patient have any chronic health conditions?" },
];

export function conditionKeysFromStored(conditionsText, selectedKeys) {
  // An explicit array (including []) is authoritative. Falling back to the
  // legacy text only when this field is absent prevents cleared chips from
  // reappearing after reload.
  if (Array.isArray(selectedKeys)) {
    return selectedKeys.filter((k) => MEDICAL_CONDITION_OPTIONS.some((o) => o.value === k));
  }
  const text = String(conditionsText || "").toLowerCase();
  if (!text) return [];
  return MEDICAL_CONDITION_OPTIONS.filter(
    (o) => text.includes(o.label.toLowerCase()) || text.includes(o.value.replace(/_/g, " "))
  ).map((o) => o.value);
}

export function conditionsLabelFromKeys(keys = []) {
  return keys
    .map((k) => MEDICAL_CONDITION_OPTIONS.find((o) => o.value === k)?.label || k)
    .filter(Boolean)
    .join(", ");
}
